import { render, staticRenderFns } from "./arrow-long.vue?vue&type=template&id=0cee8f0e&"
import script from "./arrow-long.vue?vue&type=script&lang=js&"
export * from "./arrow-long.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports